// extracted by mini-css-extract-plugin
export var createdDate = "_f2-1";
export var divider = "_f2-2";
export var headerDivider = "_f2-3";
export var messagesCard = "_f2-0";
export var messagesContainer = "_f2-6";
export var messagesContainerWrapper = "_f2-4";
export var showLeftPanelButton = "_f2-8";
export var topButtons = "_f2-7";
export var withPadding = "_f2-5";